<div *ngIf="open" class="word-modal-overlay" (click)="onOverlayClick()">
  <div class="word-modal-content" (click)="$event.stopPropagation()">
    <div class="word-modal-header">
      <h2>{{ title }}</h2>
      <div class="word-modal-actions">
        <button
          type="button"
          class="word-open-external"
          *ngIf="wordUrl && !loading"
          (click)="openInBrowser()"
          [attr.aria-label]="'dashboard.common.wordViewer.openExternal' | translate">
          {{ 'dashboard.common.wordViewer.openExternal' | translate }}
        </button>
        <button
          type="button"
          class="modal-close"
          (click)="close()"
          [attr.aria-label]="'dashboard.common.close' | translate">
          ×
        </button>
      </div>
    </div>
    <div class="word-modal-body">
      <div class="word-loading" *ngIf="loading">
        <ion-icon name="hourglass-outline" class="loading-icon"></ion-icon>
        <p>{{ 'dashboard.common.wordViewer.loading' | translate }}</p>
      </div>
      <p class="word-viewer-hint" *ngIf="safeEmbedUrl && !loading">
        {{ 'dashboard.common.wordViewer.viewerHint' | translate }}
      </p>
      <iframe
        *ngIf="safeEmbedUrl && !loading"
        class="word-viewer"
        [src]="safeEmbedUrl"
        title="{{ title }}">
      </iframe>
    </div>
  </div>
</div>
